import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    class: "",
    style: {"cursor":"pointer"},
    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.copy(_ctx.$el, _ctx.value, _ctx.id)), ["prevent"]))
  }, [
    _renderSlot(_ctx.$slots, "default"),
    _cache[1] || (_cache[1] = _createElementVNode("i", { class: "copy-link" }, null, -1))
  ]))
}